<div class="container-fluid">
  <h4>{{'Reports.Logs.header' | translate}}</h4>
  <div class="mat-elevation-z8">
    <div style="width: 100%; text-align: end; padding-bottom: 10px;">
      <i style="font-size: 1.5em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true" (click)="OnClickExport()" title="Export to Excel"></i>
    </div>
    <div class="scrollable">
      <table mat-table [dataSource]="logList" matSort matSortActive="date" matSortDisableClear matSortDirection="desc">

        <ng-container matColumnDef="statusFilter">
          <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
            <mat-select class="triggerChange" [(ngModel)]="statusFilter" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="ApplyFilterOptions(false)">
              <mat-select-trigger>
                <mat-icon class="filterIcon" color="{{this.statusFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
              </mat-select-trigger>
              <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option>
              <mat-option value="all">{{'Reports.Logs.all' | translate}}</mat-option>
              <mat-option value="clear">
                <mat-icon class="text-danger">clear</mat-icon>
              </mat-option>
              <mat-option value="warning">
                <mat-icon class="text-warning">warning</mat-icon>
              </mat-option>
              <mat-option value="error">
                <mat-icon class="text-primary">error</mat-icon>
              </mat-option>
            </mat-select>
          </th>
        </ng-container>

        <ng-container matColumnDef="usernameFilter">
          <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
            <input matInput [(ngModel)]="usernameFilter"
              style="width: 60%; height: 25px; vertical-align: middle; border: 1px solid; border-radius: 5px;">
              <mat-select class="triggerChange" [(ngModel)]="usernameFilterType" [ngModelOptions]="{standalone: true}"
                style="width: 30%;" (openedChange)="ApplyFilterOptions($event)">
                <mat-select-trigger>
                  <mat-icon class="filterIcon" color="{{this.usernameFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                </mat-select-trigger>
                <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                <mat-option value="temp">No Filter</mat-option>
                <mat-option value="contains">Contains</mat-option>
                <mat-option value="equals">Equals</mat-option>
                <mat-option value="greaterThan">Greater Than</mat-option>
                <mat-option value="lessThan">Less Than</mat-option>
              </mat-select>
            </th>
          </ng-container>
          \
          <ng-container matColumnDef="organisationFilter">
            <th mat-header-cell *matHeaderCellDef  class="tableFilterFont">
              <input matInput [(ngModel)]="organisationFilter"
                style="width: 60%; height: 25px; vertical-align: middle; border: 1px solid; border-radius: 5px;">
                <mat-select class="triggerChange" [(ngModel)]="organisationFilterType" [ngModelOptions]="{standalone: true}"
                  style="width: 30%;" (openedChange)="ApplyFilterOptions($event)">
                  <mat-select-trigger>
                    <mat-icon class="filterIcon" color="{{this.organisationFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                  </mat-select-trigger>
                  <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                  <mat-option value="temp">No Filter</mat-option>
                  <mat-option value="contains">Contains</mat-option>
                  <mat-option value="equals">Equals</mat-option>
                  <mat-option value="greaterThan">Greater Than</mat-option>
                  <mat-option value="lessThan">Less Than</mat-option>
                </mat-select>
              </th>
            </ng-container>

            <ng-container matColumnDef="eventFilter">
              <th mat-header-cell *matHeaderCellDef  class="tableFilterFont">
                <input matInput [(ngModel)]="eventFilter"
                  style="width: 60%; height: 25px; vertical-align: middle; border: 1px solid; border-radius: 5px;">
                  <mat-select class="triggerChange" [(ngModel)]="eventFilterType" [ngModelOptions]="{standalone: true}"
                    style="width: 30%;" (openedChange)="ApplyFilterOptions($event)">
                    <mat-select-trigger>
                      <mat-icon class="filterIcon" color="{{this.eventFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                    </mat-select-trigger>
                    <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                    <mat-option value="temp">No Filter</mat-option>
                    <mat-option value="contains">Contains</mat-option>
                    <mat-option value="equals">Equals</mat-option>
                    <mat-option value="greaterThan">Greater Than</mat-option>
                    <mat-option value="lessThan">Less Than</mat-option>
                  </mat-select>
                </th>
              </ng-container>

              <ng-container matColumnDef="categoryFilter">
                <th mat-header-cell *matHeaderCellDef  class="tableFilterFont">
                  <input matInput [(ngModel)]="categoryFilter"
                    style="width: 60%; height: 25px; vertical-align: middle; border: 1px solid; border-radius: 5px;">
                    <mat-select class="triggerChange" [(ngModel)]="categoryFilterType" [ngModelOptions]="{standalone: true}"
                      style="width: 30%;" (openedChange)="ApplyFilterOptions($event)">
                      <mat-select-trigger>
                        <mat-icon class="filterIcon" color="{{this.categoryFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                      </mat-select-trigger>
                      <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                      <mat-option value="temp">No Filter</mat-option>
                      <mat-option value="contains">Contains</mat-option>
                      <mat-option value="equals">Equals</mat-option>
                      <mat-option value="greaterThan">Greater Than</mat-option>
                      <mat-option value="lessThan">Less Than</mat-option>
                    </mat-select>
                  </th>
                </ng-container>

                <ng-container matColumnDef="detailsFilter">
                  <th mat-header-cell *matHeaderCellDef  class="tableFilterFont">

                    <input matInput [(ngModel)]="detailsFilter"
                      style="width: 80%; height: 25px; vertical-align: middle; border: 1px solid; border-radius: 5px;">
                      <mat-select class="triggerChange" [(ngModel)]="detailsFilterType" [ngModelOptions]="{standalone: true}"
                        style="width: 10%;" (openedChange)="ApplyFilterOptions($event)">
                        <mat-select-trigger>
                          <mat-icon class="filterIcon" color="{{this.detailsFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                        </mat-select-trigger>
                        <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                        <mat-option value="temp">No Filter</mat-option>
                        <mat-option value="contains">Contains</mat-option>
                        <mat-option value="equals">Equals</mat-option>
                        <mat-option value="greaterThan">Greater Than</mat-option>
                        <mat-option value="lessThan">Less Than</mat-option>
                      </mat-select>
                    </th>
                  </ng-container>

                  <ng-container matColumnDef="ipFilter">
                    <th mat-header-cell *matHeaderCellDef  class="tableFilterFont">

                      <input matInput [(ngModel)]="ipFilter"
                        style="width: 50%;  vertical-align: middle; height: 25px; border: 1px solid; border-radius: 5px;">
                        <mat-select class="triggerChange" [(ngModel)]="ipFilterType" [ngModelOptions]="{standalone: true}"
                          style="width: 40%;" (openedChange)="ApplyFilterOptions($event)">
                          <mat-select-trigger >
                            <mat-icon class="filterIcon" color="{{this.ipFilterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                          </mat-select-trigger>
                          <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                          <mat-option value="temp">No Filter</mat-option>
                          <mat-option value="contains">Contains</mat-option>
                          <mat-option value="equals">Equals</mat-option>
                          <mat-option value="greaterThan">Greater Than</mat-option>
                          <mat-option value="lessThan">Less Than</mat-option>
                        </mat-select>
                      </th>
                    </ng-container>

                    <ng-container matColumnDef="dateFilter">
                      <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
                        <div style="display: inline-block;">
                          <label>{{'Reports.Logs.from' | translate}}</label>
                          <mat-form-field style="visibility: hidden;width: 1px;">
                            <input matInput disabled [matDatepicker]="dpfrom" [(ngModel)]="startDateFilter"
                              [ngModelOptions]="{standalone: true}" (ngModelChange)="ApplyFilterOptions(false)">
                              <mat-datepicker #dpfrom disabled="false">
                                <mat-datepicker-actions>
                                  <button mat-raised-button color="warn"
                                  (click)="ResetDateFilter('start'); dpfrom.close()">{{'btnReset' | translate}}</button>
                                  <button mat-raised-button color="primary" matDatepickerApply>{{'btnApply' | translate}}</button>
                                </mat-datepicker-actions>
                              </mat-datepicker>
                            </mat-form-field>
                            <button mat-icon-button (click)="dpfrom.open()">
                              <mat-icon color="{{this.startDateFilterEnabled ? 'primary': 'secondary'}}">today</mat-icon>
                            </button>

                            <label>{{'Reports.Logs.to' | translate}}</label>
                            <mat-form-field style="visibility: hidden;width: 1px;">
                              <input matInput disabled [matDatepicker]="dpto" [(ngModel)]="endDateFilter"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="ApplyFilterOptions(false)">
                                <mat-datepicker #dpto disabled="false">
                                  <mat-datepicker-actions>
                                    <button mat-raised-button color="warn" (click)="ResetDateFilter('end'); dpto.close()">{{'btnReset' |
                                    translate}}</button>
                                    <button mat-raised-button color="primary" matDatepickerApply>{{'btnApply' | translate}}</button>
                                  </mat-datepicker-actions>
                                </mat-datepicker>
                              </mat-form-field>
                              <button mat-icon-button (click)="dpto.open()">
                                <mat-icon color="{{this.endDateFilterEnabled ? 'primary': 'secondary'}}">today</mat-icon>
                              </button>
                            </div>
                          </th>
                        </ng-container>

                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef style="width: 5%;"></th>
                          <td mat-cell *matCellDef="let event" style="vertical-align: top;">
                            <mat-icon class="{{ event.status }}">{{ event.icon }}</mat-icon>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="username">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; font-size: 16px;">{{'Reports.Logs.thUsername' |
                          translate}}</th>
                          <td mat-cell *matCellDef="let event" style="vertical-align: top;">
                            <mat-label class="{{(event.user.firstName !== '' ? 'underlined' : '')}} {{(event.user.firstName !== '' ? 'clickable' : '')}}" (click)="OnClickUsername(event.user)">
                            {{ event.user.username }}</mat-label>
                            @if (event.imperson) {
                              <mat-label matTooltip="{{'Impersonated by ' + event.imperson + '.'}}">*</mat-label>
                            }
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="organisation">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; font-size: 16px;">{{'Reports.Logs.lblOrg' |
                          translate}}</th>
                          <td mat-cell *matCellDef="let event" style="vertical-align: top;">
                            {{ event.user.organisation }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="event">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; font-size: 16px;">{{'Reports.Logs.thEvent' |
                          translate}}</th>
                          <td mat-cell *matCellDef="let event" style="vertical-align: top;">
                            {{ event.event }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="category">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; font-size: 16px;">{{'Reports.Logs.thCategory' |
                          translate}}</th>
                          <td mat-cell *matCellDef="let event" style="vertical-align: top;">
                            {{ event.category }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%; font-size: 16px;">{{'Reports.Logs.thDetails' |
                          translate}}</th>
                          <td mat-cell *matCellDef="let event" [innerHtml]="event.details" style="vertical-align: top;"></td>
                        </ng-container>

                        <ng-container matColumnDef="ipaddress">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; font-size: 16px;">{{'Reports.Logs.thIP' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let event" style="vertical-align: top;">
                            {{ event.ipaddress }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="date">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%; font-size: 16px;">{{'Reports.Logs.thDate' |
                          translate}}</th>
                          <td mat-cell *matCellDef="let event" style="white-space: nowrap" style="vertical-align: top; white-space: nowrap;">
                            {{ event.date | date:"d MMM yyyy h:mm:ss a" }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="loading">
                          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
                        </ng-container>

                        <ng-container matColumnDef="noData">
                          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Reports.Logs.tblLogsNoData' |
                          translate}}... </th>
                        </ng-container>

                        <tr  mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                        <tr mat-header-row class="tableFilterBgColor"
                          *matHeaderRowDef="['statusFilter', 'usernameFilter', 'organisationFilter', 'categoryFilter', 'eventFilter', 'detailsFilter', 'ipFilter', 'dateFilter']; sticky: true">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':loading === false}"></tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(logList!=null && mattableLength != 0) || loading === true}">
                        </tr>
                        <!-- <tr mat-footer-row *matFooterRowDef="['matPag'];sticky: true"></tr> -->
                      </table>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="itemsLabel">
                      <div>
                        Items per page: <input [(ngModel)]="mattablePageSize" matInput type="text" (change)="OnPagesizeChange()">
                      </div>
                      <mat-paginator [pageSize]="mattablePageSize" hidePageSize="true" [length]="mattableLength"></mat-paginator>
                    </div>
                  </div>
                </div>
